import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Title } from '@nerdwallet/react-typography';
import StoryCard from './story-card';

import { repeatable, titleInput } from '../../lib/editing-configs';

import styles from './story-cards.module.less';

const StoryCards = ({ title, cards }) => {
  const StoryCardsBlock = cards.map((card) => (
    <StoryCard {...card} key={card.title} />
  ));

  return (
    <div className={styles['story-cards__cont']}>
      {title ? (
        <div className={styles['story-cards-hdr__cont']}>
          <Title size="large" className={styles['story-cards-hdr']}>
            {title}
          </Title>
        </div>
      ) : null}
      <ul className={styles['story-cards__cards']}>{StoryCardsBlock}</ul>
    </div>
  );
};

StoryCards.displayName = 'StoryCards';

StoryCards.propTypes = {
  title: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkUrl: PropTypes.string,
      previewImg: PropTypes.string,
    })
  ),
};

StoryCards.defaultProps = {
  title: '',
  cards: [],
};

StoryCards.getEditingConfig = () => [
  titleInput,
  repeatable('cards', 'Elements', 'Element', () =>
    StoryCard.getEditingConfig()
  ),
];

export default StoryCards;
